import * as React from 'react';

import './Transcript.css';

import { IAlignedWord } from '../api';
import Paragraph from './Paragraph';

interface IProps {
  alignment: IAlignedWord[],
  currentTime: number,
  isSeeking: boolean,
  onSeek: (id: string, t: number) => void,
  trackID: string,
  transcript: string,
}

class Transcript extends React.PureComponent<IProps> {

  // private wordOffsets = {};

  // public componentWillReceiveProps(nextProps: IProps) {
  //   if (nextProps.isSeeking) {
  //     this.scrollToTime(nextProps.currentTime);
  //   }
  // }

  // public componentDidMount() {
  //   setTimeout(() => {
  //     this.scrollToTime(this.props.currentTime);
  //   }, 500);
  // }

  public render() {
    const {
      alignment,
      transcript,
    } = this.props;
    
    const offsets: number[] = [];
    const re = /\n\n/g;
    while (re.exec(transcript)) {
      offsets.push(re.lastIndex);
    }

    const paragraphs: IAlignedWord[][] = [[]];

    alignment.forEach(word => {
      const nextOffset = offsets[0];

      if (word.textStart > nextOffset) {
        offsets.shift();
        paragraphs.push([]);
      }

      paragraphs[paragraphs.length - 1].push(word);
    });

    return (<section className="transcript-section">
      <div className="transcript-view">
          {paragraphs.map(this.renderParagraph)}
      </div>
    </section>);
  }

  private renderParagraph = (para: IAlignedWord[], i: number) => {
    const {
      currentTime,
      onSeek,
      trackID,
      transcript,
    } = this.props;

    return (<Paragraph
      currentTime={currentTime}
      key={i} 
      onClick={onSeek}
      trackID={trackID}
      transcript={transcript}
      words={para} />);
  }

  // private scrollToTime(t: number) {
  //   const i = this.currentWordIdx(t);
  //   if (i < 0) {
  //     return;
  //   }
  //   const offset = this.wordOffsets[i];
  //   if (offset > (window.scrollY + window.innerHeight)) {
  //     window.scrollTo(0, offset - 100);
  //   }
  // }

  // // PERF(maxhawkins): use faster search
  // private currentWordIdx(t: number) {
  //   const {alignment} = this.props;
  //   for (let i = 0; i < alignment.length; i++) {
  //     const align = alignment[i];

  //     const end = align.start + align.duration;
  //     if (end > t) {
  //       return i;
  //     }
  //   }

  //   return -1;
  // }

  // private onClickWord = (word: IAlignedWord) => {
  //   this.props.onSeek(this.props.trackID, word.start);
  // }

  // private onWordRef = (el: Word | null) => {
  //   if (!el) { return; }

  //   const {index} = el.props;

  //   const node = ReactDOM.findDOMNode(el);
  //   if (!(node instanceof Element)) { return; }

  //   const {top} = node.getBoundingClientRect();
  //   this.wordOffsets[index] = top;
  // }

}

export default Transcript;



// WEBPACK FOOTER //
// ./src/components/Transcript.tsx